import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "col md:col-6" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "secondary-text mobile" }
const _hoisted_7 = { class: "secondary-text desktop" }
const _hoisted_8 = { class: "col sm:col-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_Select = _resolveComponent("Select")!
  const _component_FileInput = _resolveComponent("FileInput")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_FileDisplay = _resolveComponent("FileDisplay")!
  const _component_image_selector = _resolveComponent("image-selector")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    modelValue: _ctx.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
    schema: _ctx.schema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_FormInput, {
            value: _ctx.model.title,
            id: "edit-document-title",
            name: "title",
            label: "Title",
            disabled: !_ctx.editable,
            onChange: _ctx.handleChange
          }, null, 8, ["value", "disabled", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_FormInput, {
            value: _ctx.model.description,
            id: "edit-document-description",
            name: "description",
            label: "Description",
            disabled: !_ctx.editable,
            onChange: _ctx.handleChange
          }, null, 8, ["value", "disabled", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Select, {
            id: "edit-document-signature-required",
            name: "signature",
            label: "documents.signature-required",
            placeholder: "form.placeholder.select",
            value: _ctx.model.signature?.toLowerCase(),
            items: _ctx.signatureItems,
            error: _ctx.errors.signature,
            required: "",
            onChange: _ctx.handleSelectChange
          }, null, 8, ["value", "items", "error", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (!_ctx.model.useFileUrl)
            ? (_openBlock(), _createBlock(_component_FileInput, {
                key: 0,
                acceptString: _ctx.fileUploadAccept,
                existingFile: _ctx.model.file,
                onAddFile: _ctx.handleAddFile
              }, null, 8, ["acceptString", "existingFile", "onAddFile"]))
            : (_ctx.model.useFileUrl)
              ? (_openBlock(), _createBlock(_component_FormInput, {
                  key: 1,
                  id: "input-file-url",
                  name: "fileUrl",
                  label: "Input text |",
                  type: "text",
                  value: _ctx.model.fileUrl,
                  hideLabelOnFocus: "",
                  onChange: _ctx.handleChange
                }, null, 8, ["value", "onChange"]))
              : _createCommentVNode("", true),
          _createVNode(_component_Button, {
            variant: "link",
            text: 
            !_ctx.model.useFileUrl
              ? 'setup.welcome.use-file-url'
              : 'setup.welcome.use-file-upload'
          ,
            onClick: _ctx.toggleFileUrl
          }, null, 8, ["text", "onClick"])
        ]),
        (_ctx.model.fileIsLoading)
          ? (_openBlock(), _createBlock(_component_FileDisplay, {
              key: 0,
              fileName: '',
              fileType: 'video',
              isLoading: _ctx.model.fileIsLoading
            }, _createSlots({ _: 2 }, [
              (_ctx.model.fileIsLoading)
                ? {
                    name: "secondaryText",
                    fn: _withCtx(() => [
                      _createElementVNode("span", _hoisted_6, [
                        _createVNode(_component_TranslatedText, { path: "common.processing" })
                      ]),
                      _createElementVNode("span", _hoisted_7, [
                        _createVNode(_component_TranslatedText, { path: "common.video-processing" })
                      ])
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["isLoading"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
          _createVNode(_component_image_selector, {
            type: "image",
            title: "Placeholder",
            placeholderImage: _ctx.model.placeholderUrl,
            previewStyle: _ctx.getPlaceholderPreviewStyle,
            onChange: _ctx.setPlaceholder
          }, null, 8, ["placeholderImage", "previewStyle", "onChange"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "schema"]))
}